(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grand-opening-popup"]) return;
  try {
    
  function setupGrandOpeningPopup() {
    const dialog = document.getElementById('grand-opening-popup');
    if (!dialog || dialog.dataset.bound === 'true') return;
    dialog.dataset.bound = 'true';
    const designMode = dialog.dataset.designMode === 'true';
    let dismissed = false;
    try { dismissed = sessionStorage.getItem('thanksgiving-2026-popup-dismissed') === 'true'; } catch (_) {}
    if (designMode || !dismissed) {
      window.setTimeout(() => { if (dialog.isConnected && !dialog.open) dialog.showModal(); }, designMode ? 0 : Number(dialog.dataset.delay || 1500));
    }
    dialog.querySelector('[data-popup-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      if (!designMode) { try { sessionStorage.setItem('thanksgiving-2026-popup-dismissed', 'true'); } catch (_) {} }
    });
    dialog.querySelector('.grand-opening-popup__button')?.addEventListener('click', () => dialog.close());
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupGrandOpeningPopup);
  else setupGrandOpeningPopup();
  document.addEventListener('shopify:section:load', setupGrandOpeningPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
